// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"231":"component---src-pages-video-js","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"231":"5ab56383aa432ab8fb49","532":"9358739d364dae5d8443","678":"a614bd847ee64f277eaa","883":"08ad030942851fea14a0"}[chunkId] + ".js";
};